 // Industry (Branchen) page data structure
 export interface IndustryPage {
   slug: string;
   seoKey: string;
   title: string;
   subtitle: string;
   description: string;
   canonicalUrl: string;
   keywords: string;
   breadcrumbLabel: string;
   serviceName: string;
   serviceDescription: string;
   // Component keys for dynamic rendering
   componentSet: "maschinenbau" | "versicherung" | "einzelhandel" | "it-software" | "e-commerce" | "tourismus" | "verbaende";
 }
 
 export const industryPages: IndustryPage[] = [
   {
     slug: "maschinenbau",
     seoKey: "maschinenbau",
     title: "AI Agent für Maschinenbau – Technischer Kundenservice | Chathero",
     subtitle: "Technischer Support rund um die Uhr",
     description: "Spezialisierter AI Agent für die Maschinenbaubranche. Technische Anfragen automatisieren, Ersatzteil-Support optimieren und 24/7 Service bieten.",
     canonicalUrl: "https://chathero.ai/branchen/maschinenbau",
     keywords: "Maschinenbau Chatbot, technischer Support KI, Ersatzteil Bot, Industrie 4.0, B2B Kundenservice, Manufacturing AI",
     breadcrumbLabel: "Maschinenbau",
     serviceName: "Chathero für Maschinenbau",
     serviceDescription: "AI Agent-Lösung speziell für den Maschinenbau: Technischer Support, Ersatzteil-Bestellung, mehrsprachige Beratung.",
    componentSet: "maschinenbau",
  },
  {
    slug: "versicherung",
    seoKey: "versicherung",
    title: "AI Agent für Versicherungen – Automatisierte Kundenberatung | Chathero",
    subtitle: "Automatisierte Kundenberatung rund um die Uhr",
    description: "Spezialisierter AI Agent für die Versicherungsbranche. Schadenaufnahme, Tarifberatung und Vertragsverwaltung automatisieren – DSGVO-konform.",
    canonicalUrl: "https://chathero.ai/branchen/versicherung",
    keywords: "Versicherung Chatbot, Schadenaufnahme KI, Tarifberatung Bot, InsurTech, Kundenservice Versicherung, DSGVO",
    breadcrumbLabel: "Versicherungen",
    serviceName: "Chathero für Versicherungen",
    serviceDescription: "AI Agent-Lösung speziell für Versicherungen: Schadenaufnahme, Tarifberatung, Vertragsverwaltung.",
    componentSet: "versicherung",
  },
  {
    slug: "einzelhandel",
    seoKey: "einzelhandel",
    title: "AI Agent für Einzelhandel – Digitale Kundenberatung | Chathero",
    subtitle: "Persönliche Beratung – digital und rund um die Uhr",
    description: "Spezialisierter AI Agent für den Einzelhandel. Produktempfehlungen, Verfügbarkeitsanfragen und Kundenservice automatisieren – online und stationär.",
    canonicalUrl: "https://chathero.ai/branchen/einzelhandel",
    keywords: "Einzelhandel Chatbot, Retail KI, Produktberatung Bot, Verkaufsberater KI, Kundenservice Handel, Omnichannel",
    breadcrumbLabel: "Einzelhandel",
    serviceName: "Chathero für Einzelhandel",
    serviceDescription: "AI Agent-Lösung speziell für den Einzelhandel: Produktberatung, Verfügbarkeitsauskunft, After-Sales Service.",
    componentSet: "einzelhandel",
  },
  {
    slug: "it-software",
    seoKey: "itSoftware",
    title: "AI Agent für IT & Software – Technischer Support & Onboarding | Chathero",
    subtitle: "Technischer Support und Onboarding – automatisiert und skalierbar",
    description: "Spezialisierter AI Agent für IT- und Softwareunternehmen. Ticket-Triage, Self-Service Onboarding und technische Dokumentation – sofort verfügbar.",
    canonicalUrl: "https://chathero.ai/branchen/it-software",
    keywords: "IT Chatbot, Software Support KI, Ticket-Triage Bot, SaaS Onboarding, Tech Support AI, B2B Software",
    breadcrumbLabel: "IT & Software",
    serviceName: "Chathero für IT & Software",
    serviceDescription: "AI Agent-Lösung speziell für IT & Software: Tech-Support, Ticket-Triage, Self-Service Onboarding.",
    componentSet: "it-software",
  },
  {
    slug: "e-commerce",
    seoKey: "eCommerce",
    title: "AI Agent für E-Commerce – Kaufberatung & Service | Chathero",
    subtitle: "Mehr Umsatz durch intelligente Kaufberatung und automatisierten Service",
    description: "Spezialisierter AI Agent für E-Commerce. Conversion steigern, Warenkorbabbrüche reduzieren und Kundenservice automatisieren – rund um die Uhr.",
    canonicalUrl: "https://chathero.ai/branchen/e-commerce",
    keywords: "E-Commerce Chatbot, Online-Shop KI, Kaufberatung Bot, Conversion Optimierung, Warenkorbabbrüche, Shop Automatisierung",
    breadcrumbLabel: "E-Commerce",
    serviceName: "Chathero für E-Commerce",
    serviceDescription: "AI Agent-Lösung speziell für E-Commerce: Kaufberatung, Bestellstatus, Retouren-Management.",
    componentSet: "e-commerce",
  },
  {
    slug: "tourismus",
    seoKey: "tourismus",
    title: "AI Agent für Tourismus & Reise – Digitale Reiseberatung | Chathero",
    subtitle: "Persönliche Reiseberatung – digital und rund um die Uhr",
    description: "Spezialisierter AI Agent für die Tourismusbranche. Reiseberatung, Buchungsunterstützung und mehrsprachiger Service – automatisiert und rund um die Uhr.",
    canonicalUrl: "https://chathero.ai/branchen/tourismus",
    keywords: "Tourismus Chatbot, Reise KI, Buchungsbot, Hotel Chatbot, Reiseberatung AI, mehrsprachiger Service",
    breadcrumbLabel: "Tourismus",
    serviceName: "Chathero für Tourismus",
    serviceDescription: "AI Agent-Lösung speziell für Tourismus: Reiseberatung, Buchungsunterstützung, mehrsprachiger Service.",
    componentSet: "tourismus",
  },
  {
    slug: "verbaende",
    seoKey: "verbaende",
    title: "AI Agent für Verbände & öffentliche Träger – Automatisierte Kommunikation | Chathero",
    subtitle: "Automatisierte Mitglieder- und Bürgerkommunikation rund um die Uhr",
    description: "Spezialisierter AI Agent für Verbände und öffentliche Träger. Mitglieder-, Service- und Bürgeranfragen automatisieren – DSGVO-konform und effizient.",
    canonicalUrl: "https://chathero.ai/branchen/verbaende",
    keywords: "Verband Chatbot, öffentlicher Träger KI, Kommune Chatbot, Mitgliederkommunikation, Bürgerkommunikation, DSGVO",
    breadcrumbLabel: "Verbände & öffentliche Träger",
    serviceName: "Chathero für Verbände & öffentliche Träger",
    serviceDescription: "AI Agent-Lösung speziell für Verbände und öffentliche Träger: Mitgliederservice, Bürgerberatung, Veranstaltungsinformation.",
    componentSet: "verbaende",
  },
];
 
 export const getIndustryPageBySlug = (slug: string): IndustryPage | undefined => {
   return industryPages.find((page) => page.slug === slug);
 };
 
 export const getAllIndustrySlugs = (): string[] => {
   return industryPages.map((page) => page.slug);
 };